const GlobalSiteTagService = {
    addConversionEvent: (id: string) => {
        if (window.gtag) {
            gtag('event', 'conversion', { send_to: `AW-419572662/${id}` });
        }
    },
};

export default GlobalSiteTagService;
